import moment from 'moment';

// A trend row is labelled by the raw response date ("2025-04-18T00:00:00.000Z")
// while a clicked bucket is often known only by its ISO start ("2025-04-18"),
// so a plain equality check misses it. Day-or-coarser buckets compare on the
// calendar date; an hourly bucket (a non-midnight time) on the full instant.
const toDateKey = (label: string): string | undefined => {
  if (!/^\d{4}-\d{2}-\d{2}/.test(label)) {
    return undefined;
  }
  const date = moment.utc(label, moment.ISO_8601, true);
  if (!date.isValid()) {
    return undefined;
  }
  const isMidnight =
    date.hours() === 0 && date.minutes() === 0 && date.seconds() === 0;
  return isMidnight ? date.format('YYYY-MM-DD') : date.toISOString();
};

// Whether a digest row's label names the same row as `label`. Shared by the
// pinning (pinRows) and the read-back (mergeFocusIntoView) so the two can never
// disagree about which row the user clicked.
const isSameRowLabel = ({
  rowLabel,
  label,
}: {
  rowLabel: string;
  label: string;
}): boolean => {
  if (rowLabel === label) {
    return true;
  }
  const rowKey = toDateKey(rowLabel);
  return rowKey !== undefined && rowKey === toDateKey(label);
};

export default isSameRowLabel;
